export default "__VITE_ASSET__Bm7GQNrr__"